// What the Playground and the Debugger say when a URL names a session or an execution the revision on
// screen cannot resolve. One wording for both surfaces, and it never says which way it went wrong:
// docs/specs/2026-09-18-revision-selection.md#a-session-link-that-points-elsewhere.

function unavailable(kind, id) {
  return `${kind} ${id} is not available in the revision on screen. `
    + `It may belong to another revision, or it may no longer exist.`;
}

export function sessionUnavailableMessage(sessionId) {
  return unavailable("Session", sessionId);
}

export function executionUnavailableMessage(executionId) {
  return unavailable("Execution", executionId);
}

// Whether a rejected session- or execution-scoped read is the revision refusing the reference. 403
// only: everything else is transient, and calling it a bad link sends the reader hunting a URL that is
// fine. SessionView.isSessionGone reads the same wire fact for another question, deliberately apart.
export function isSessionUnavailable(error) {
  return error?.response?.status === 403;
}
